















import { Component, Vue, Prop } from "vue-property-decorator";
import { DateTime } from "luxon";

@Component
export default class DayTrack extends Vue {
  @Prop({ required: true }) from?: DateTime;
  @Prop({ required: true }) to?: DateTime;
  @Prop({ default: 32 }) w?: number;
  @Prop({ default: 32 }) h?: number;
  @Prop() isMobile?: boolean;
  @Prop() isContingent?: boolean;

  get todayMarkerPos() {
    if (this.from && this.w) {
      if (this.from.month === DateTime.local().month && this.from.year === DateTime.local().year) {
        const day = DateTime.local().day;
        return {
          position: "absolute",
          left: `${this.w * (day - this.from.day + 0.5) - 8}px`,
          top: `${-36 + 8}px`,
        };
      }
    }

    return { display: "none" };
  }

  get days(): DateTime[] {
    if (!this.from || !this.to) return [];
    const f = this.from;
    return Array.from(
      Array(Math.ceil(this.to.diff(this.from, "days").days)),
      (_, i) => f.plus({ days: i })
    );
  }

  get dimensions() {
    return {
      width: this.w + "px",
      height: this.h + "px",
    };
  }

  dayClass(day: DateTime) {
    const isToday = day.toISODate() === DateTime.local().toISODate();
    return {
      "primary--text": !isToday && day.weekday <= 5,
      "accent--text": !isToday && day.weekday > 5,
      "white--text primary lighten--2": isToday && !this.isMobile && !this.isContingent,
      "black--text": isToday && !this.$vuetify.theme.dark && this.isMobile,
      "white--text": isToday && this.$vuetify.theme.dark && this.isMobile,
      "no-border" : this.isMobile,
    };
  }
}
